/**
 * @generated SignedSource<<fab65692b0ec3cbb361b23afe30be622>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersSectionStoryStyleGetDeDuplicatedCombinedArticleListQuery$data = {
  readonly celeb: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly kpop: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly leisure: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly luxury: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly tech: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly trends: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly well: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "helpersSectionStoryStyleGetDeDuplicatedCombinedArticleListQuery";
};
export type helpersSectionStoryStyleGetDeDuplicatedCombinedArticleListQuery$key = {
  readonly " $data"?: helpersSectionStoryStyleGetDeDuplicatedCombinedArticleListQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersSectionStoryStyleGetDeDuplicatedCombinedArticleListQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersSectionStoryStyleGetDeDuplicatedCombinedArticleListQuery"
};

(node as any).hash = "aa49f98e9d895d05907cc99977e9dc25";

export default node;
